// Libs
import io from 'socket.io-client'

let token = null
let socket =  null

const notifyMiddleware = store => next => action => {
  if(action.type === 'change_user' || action.type === 'change_user_field' || action.type === 'reload_user') {
    token = localStorage.getItem('token')

    // If there's previous socket then disconnect
    socket && socket.disconnect()

    // Clear notifications state
    next({ type: 'load_notifications', payload: [] })

    // Create socket connection
    socket = io('https://notify.semprocesso.com.br', { query: 'token=' + token })

    // Emit find notifications event
    socket.emit('find notifications');

    // Handle load notifications event
    socket.on('load notifications', data => {
      next({ type: 'load_notifications', payload: data })
    });

    // Handle reset notifications event
    socket.on('reset notifications', () => {
      // Emit find notifications event
      socket.emit('find notifications');
    })
  }

  // TODO: use another action type instead action type 'change_success'
  if(action.type === 'change_chat' ||
    (action.type === 'change_success' && action.payload === 'O convite foi enviado com sucesso. Acompanhe este caso na aba "Em Análise"')) {
    // Emit reset notifications event
    socket.emit('change');
  }

  next(action)
}

export default notifyMiddleware
